<div class="landing-page" id="top">
  <div class="bg-orb orb-a" aria-hidden="true"></div>
  <div class="bg-orb orb-b" aria-hidden="true"></div>
  <div class="bg-orb orb-c" aria-hidden="true"></div>
  <div class="bg-grid" aria-hidden="true"></div>

  <header class="top-nav section-shell">
    <a [routerLink]="[]" fragment="top" class="brand" aria-label="CognitoX home">
      <img [src]="logoPath" alt="CognitoX logo" class="brand-logo" />
      <span class="brand-text">CognitoX</span>
    </a>

    <nav class="top-links" aria-label="Primary navigation">
      <a [routerLink]="[]" fragment="features">Features</a>
      <a [routerLink]="[]" fragment="workflow">Workflow</a>
      <a [routerLink]="[]" fragment="highlights">Highlights</a>
      <a [routerLink]="[]" fragment="access">Access</a>
    </nav>

    <a [routerLink]="['/auth/login']" class="btn btn-primary" aria-label="Go to dashboard login">
      Dashboard
    </a>
  </header>

  <main>
    <!-- Hero: open text layout + metric sidebar -->
    <section class="hero section-shell full-hero">
      <div class="hero-copy">
        <p class="eyebrow">Unified operations and digital workflows</p>
        <h1>CognitoX brings operations, commerce, and content into <em>one decisive control plane</em>.</h1>
        <p class="hero-subtitle">
          Execute inventory, sales, billing, HR, CRM, engagement, and web publishing from a single, structured platform designed for scale.
        </p>

        <div class="hero-actions">
          <a [routerLink]="['/auth/login']" class="btn btn-primary" aria-label="Open dashboard login">
            Go to Dashboard
          </a>
          <a [routerLink]="[]" fragment="features" class="btn btn-ghost" aria-label="Explore feature sections">
            Explore Features
          </a>
        </div>
      </div>

      <div class="hero-panel">
        <div class="metric-card" *ngFor="let metric of metrics">
          <strong>{{ metric.value }}</strong>
          <span>{{ metric.label }}</span>
        </div>
      </div>
    </section>

    <!-- Value strip: 4 platform pillars -->
    <section class="value-strip section-shell" aria-label="Platform values">
      <article class="value-item glass-panel" *ngFor="let value of valueItems">
        <h3>{{ value.title }}</h3>
        <p>{{ value.description }}</p>
      </article>
    </section>

    <!-- Features -->
    <section id="features" class="section-shell feature-section">
      <div class="section-heading">
        <p class="eyebrow">Feature Constellation</p>
        <h2>Everything needed to operate, engage, and scale.</h2>
      </div>

      <div class="feature-board glass-panel">
        <div class="feature-grid">
          <article class="feature-group" *ngFor="let group of featureGroups">
            <div class="feature-group-head">
              <div class="icon-box"><i [class]="group.icon" aria-hidden="true"></i></div>
              <h3>{{ group.title }}</h3>
            </div>
            <p class="group-summary">{{ group.summary }}</p>

            <ul class="feature-list">
              <li *ngFor="let item of group.items">
                <span class="fi-name">{{ item.name }}</span>
                <span class="fi-desc">{{ item.description }}</span>
              </li>
            </ul>
          </article>
        </div>
      </div>
    </section>

    <!-- Workflow -->
    <section id="workflow" class="section-shell workflow">
      <div class="section-heading">
        <p class="eyebrow">Execution Flow</p>
        <h2>Simple rhythm from setup to optimization.</h2>
      </div>

      <div class="workflow-grid">
        <article class="workflow-step glass-panel" *ngFor="let step of workflowSteps; index as i">
          <span class="step-number">0{{ i + 1 }}</span>
          <h3>{{ step.title }}</h3>
          <p>{{ step.description }}</p>
        </article>
      </div>
    </section>

    <!-- Highlights: proper section heading + card grid -->
    <section id="highlights" class="section-shell highlight-section">
      <div class="section-heading">
        <p class="eyebrow">Spotlight Modules</p>
        <h2>Engineered for critical operational functions.</h2>
      </div>

      <div class="highlight-stack">
        <article class="highlight glass-panel" *ngFor="let spotlight of spotlightItems">
          <p class="eyebrow">{{ spotlight.title }}</p>
          <h3>{{ spotlight.headline }}</h3>
          <p>{{ spotlight.description }}</p>
          <ul>
            <li *ngFor="let bullet of spotlight.bullets">{{ bullet }}</li>
          </ul>
        </article>
      </div>
    </section>

    <!-- Access banner: full-width dark section -->
    <section id="access" class="access-wrap" aria-label="Dashboard access">
      <div class="access-banner section-shell">
        <div class="access-text">
          <p class="eyebrow">Ready to start?</p>
          <h2>Access your dashboard and continue where your team left off.</h2>
        </div>
        <a [routerLink]="['/auth/login']" class="btn btn-access" aria-label="Access dashboard now">
          Access Dashboard
        </a>
      </div>
    </section>
  </main>

</div>
